import NonLinearSlider from './non_linear_slider';
export default NonLinearSlider;
